import TaskFormModal from './projects/TaskFormModal';
import type { TaskPlacement } from './engagements/EngagementChainFields';
import type { ChainLock } from './engagements/engagementChainModel';

/**
 * "משימה חדשה" from anywhere (QuickCreate, /tasks, Home "סדר היום"). A thin
 * wrapper over the one task form, `components/projects/TaskFormModal` (create
 * mode): customer → type → engagement → milestone (P-02b, plan §6.1), with
 * the screen's placement pre-filled / locked (§6.2).
 */
export default function CreateTaskModal({
  onClose,
  onSuccess,
  placement,
  lock,
  initialDueDate,
}: {
  onClose: () => void;
  /** Called after the task was created. */
  onSuccess: (ticketId?: string, projectId?: string, engagementId?: string) => void;
  /** Where the form opens (QuickCreate context, remembered engagement). */
  placement?: TaskPlacement;
  /** How far down `placement` is fixed. */
  lock?: ChainLock;
  /** Pre-fill the due date (`YYYY-MM-DD`), e.g. from a day picked in Home "סדר היום". */
  initialDueDate?: string;
}) {
  return (
    <TaskFormModal
      mode="create"
      placement={placement}
      lock={lock}
      initialDueDate={initialDueDate}
      onClose={onClose}
      onCreated={(ticketId, placed) => {
        onSuccess(ticketId, placed.projectId ?? undefined, placed.engagementId);
        onClose();
      }}
    />
  );
}
